import AccessTime from '@mui/icons-material/AccessTime'
import { Button, DialogActions, DialogContent, CircularProgress } from '@mui/material'
import dayjs from 'dayjs'
import { Suspense, useEffect, useMemo, useState } from 'react'
import { toast } from 'react-toastify'
import { TimeRangePicker } from 'src/consumer/components/helperComponents/dynamic'
import {
  getDataMapFromCommonResponse,
  getMessageMapFromCommonResponse,
  isCommonResponseSuccessfulV2,
} from 'src/mentor/helpers/utilityFunctions'
import { postSPData } from 'src/supportPortal/services/services'

export default function MyClinicRosterForm({
  selectedSlot,
  selectedItem,
  legendItems,
  getSidebarLegendValue,
  getSidebarLegendLabel,
  updateSlotOnCalendar,
  addEventToSlotList,
  slotSaveApiSignature = '/api/secure/teacher/clinic-roster/assign-to-chamber',
  dropDownKey = 'mentorId',
  dropDownLabel = 'Mentor',
  closePopup,
  transformToSaveItem = ({ rosterSaveItem, allSidebarItems }) => {
    return rosterSaveItem
  },
}) {
  const [rosterSlot, setRosterSlot] = useState()
  const currentDateInDayJs = dayjs(rosterSlot?.customDate)
  const [saving, setSaving] = useState(false)
  const isRosterSlotValid = useMemo(() => {
    if (!rosterSlot) {
      return false
    }
    if (!rosterSlot?.mentorId) {
      return false
    }
    return true
  }, [rosterSlot])

  async function saveSlot() {
    setSaving(true)
    const resp = await postSPData(
      slotSaveApiSignature,
      transformToSaveItem({ rosterSaveItem: rosterSlot, allSidebarItems: legendItems }),
    )
    if (resp.status === 200) {
      if (isCommonResponseSuccessfulV2(resp)) {
        const rosterItem = getDataMapFromCommonResponse(resp)?.['clinic-roster-slot']
        addEventToSlotList(rosterItem)
        closePopup()
        return
      } else {
        toast.error(`${getMessageMapFromCommonResponse(resp)}`)
      }
    }
    setSaving(false)
  }

  function handleChangeDate([startTime, endTime]) {
    updateSlotOnCalendar({
      date: rosterSlot?.customDate,
      startTime,
      endTime,
    })

    setRosterSlot((prev) => ({
      ...prev,
      slotStartTime: startTime,
      slotEndTime: endTime,
    }))
  }

  useEffect(() => {
    console.log({ selectedSlot })
    setRosterSlot(selectedSlot)
  }, [selectedSlot])

  console.log({ rosterSlot })

  return (
    <>
      <DialogContent>
        <div className="d-flex align-items-center gap-1">
          <AccessTime />
          <span>{currentDateInDayJs.format('dddd, D MMMM')}</span>
          <Suspense fallback={<CircularProgress size={20} />}>
            <TimeRangePicker
              value={[rosterSlot?.slotStartTime, rosterSlot?.slotEndTime]}
              onChange={handleChangeDate}
              valueFormat="HH:mm"
              labelFormat="HH:mm"
            />
          </Suspense>
        </div>
      </DialogContent>
      <DialogActions>
        <Button onClick={closePopup}>Cancel</Button>
        <Button disabled={!isRosterSlotValid || saving} onClick={saveSlot} variant="contained">
          Save
        </Button>
      </DialogActions>
    </>
  )
}
